<div class="login-container">
  <!-- Show loading state while checking authentication -->
  @if (authState === 'loading') {
  <div class="loading-state">
    <div class="spinner-border text-white" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3 text-white">Checking authentication status...</p>
  </div>
  }

  <!-- Show login form when not authenticated -->
  @if (authState === 'signIn') {
  <div class="auth-wrapper">
    <div class="mb-4 text-center">
      <h2>Welcome Back</h2>
      <p class="text-muted">Please sign in to continue</p>
    </div>
    <amplify-authenticator [socialProviders]="[]" [signUpAttributes]="['email']" [hideSignUp]="true">
      <ng-template amplifySlot="authenticated" let-user="user" let-signOut="signOut">
        <!-- This should rarely be shown as we redirect on auth -->
        <div class="text-center p-4">
          <h3>Welcome, {{ userName || user.username }}!</h3>
          <button type="button" class="btn btn-secondary" (click)="signOut()">Sign Out</button>
        </div>
      </ng-template>
    </amplify-authenticator>
  </div>
  }

  <!-- Show authenticated state -->
  @if (authState === 'signedIn') {
  <div class="authenticated-state">
    <div class="alert alert-success">
      <h4>You are signed in!</h4>
      <p>Redirecting to dashboard...</p>
    </div>
  </div>
  }
</div>
